import { Form, Input, Row, Col, Switch, Select, DatePicker, InputNumber, Tooltip } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import { getMembershipLevelData } from './MembershipRechargePlansEdit';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import MembershipPhysicalCardEdit from './MembershipPhysicalCardEdit';

const EditComponent = (props: any) => {
    const apiId = 'membership';
    const [form] = Form.useForm();
    const { editMode, editingId, defaultService } = props;
    const ref = useRef<any>(undefined);
    const [membershipData, setMembershipData] = useState<any>();
    const [membershipTypeData, setMembershipTypeData] = useState<any>();
    const [membershipLevelData, setMembershipLevelData] = useState<any>();
    const [verificationMethodData, setVerificationMethodData] = useState<any>();
    const [membershipStatusData, setMembershipStatusData] = useState<any>();
    const [merchantData, setMerchantData] = useState<any>();
    const [shopData, setShopData] = useState<any>();
    const [membershipMode, setMembershipMode] = useState<any>();
    const [membershipInfoData, setMembershipInfoData] = useState<any>();

    useEffect(() => {
        if (ref.current) {
            ref.current.getRow?.then((res: any) => {
                if (res?.success === true) {
                    getMembershipLevelData(res.data.membershipTypeId,
                        defaultService,
                        setMembershipLevelData);
                }
            })
        }
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'membershipInfo',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMembershipInfoData(res.data);
                }
            })
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'membership',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMembershipData(res.data);
                }
            })
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'membershipType',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMembershipTypeData(res.data);
                }
            })
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'merchant',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMerchantData(res.data);
                }
            })
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'shop',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setShopData(res.data);
                }
            })
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'verificationMethod@membershipStatus@membershipMode',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { verificationMethod, membershipStatus, membershipMode } = res.data;
                    setVerificationMethodData(verificationMethod);
                    setMembershipStatusData(membershipStatus);
                    setMembershipMode(membershipMode);
                }
            })
    }, []);

    const subExtendProps: WebUniversalProps = {
        ...props,
        titleName: '会员实体卡',
        apiId: 'membershipPhysicalCard',
        editOptions: {
            Editor: MembershipPhysicalCardEdit
        },
        columns: [
            {
                title: '实体卡id',
                dataIndex: 'id'
            }, {
                title: '备注',
                dataIndex: 'memo',
                render: (val: any) => <Tooltip placement="topLeft" title={val}>{
                    (typeof val !== "undefined" && val !== null) ?
                        (val.length >= 8 ? `......${val.substring(val.length - 8, val.length)}` : val)
                        : ''
                }</Tooltip>
            }],
        serviceId: 'business',
        displayOptions: {
            showAdd: false,
            showQuery: false
        }
    };

    const extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        serviceId: 'business',
        displayOptions: {
            width: 850
        },
        dateOptions: {
            columnNames: ['pointsExpire', 'giftsExpire', 'expireDate', 'dateOfBirth']
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={8}>
                        <Form.Item
                            label="ID"
                            tooltip='会员id，不输入自动生成'
                            name="id">
                            <Input disabled={editMode === 'NEW' ? false : true} />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="类型"
                            name="membershipTypeId"
                            tooltip='会员类型'
                            rules={[{ required: true, message: '请选择会员类型!' }]}>
                            <Select
                                placeholder="会员类型"
                                onChange={(e) => {
                                    form.setFieldValue('membershipLevelId', null);
                                    getMembershipLevelData(e,
                                        defaultService,
                                        setMembershipLevelData
                                    );
                                }}
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general(membershipTypeData, { itemName: 'typeName' })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="实体卡上限"
                            name="maxPhysicalCards"
                            tooltip='绑定实体卡数量的上限'>
                            <InputNumber style={{ width: 160 }} />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="积分"
                            name="points">
                            <InputNumber style={{ width: 120 }} />
                        </Form.Item>
                    </Col>

                    <Col span={7}>
                        <Form.Item
                            label="积分到期"
                            name="pointsExpire">
                            <DatePicker format="YYYY-MM-DD" style={{ width: 140 }} />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="会员"
                            name="membershipInfoId"
                            tooltip='会员信息'>
                            <Select
                                placeholder="会员信息"
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general(membershipInfoData, { itemName: 'membershipName' })}
                            </Select>
                        </Form.Item>
                    </Col>


                    <Col span={6}>
                        <Form.Item
                            label="密码"
                            name="password">
                            <Input.Password />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="赠送"
                            name="gifts">
                            <InputNumber style={{ width: 120 }} />
                        </Form.Item>
                    </Col>

                    <Col span={7}>
                        <Form.Item
                            label="赠送到期"
                            name="giftsExpire">
                            <DatePicker format="YYYY-MM-DD" style={{ width: 140 }} />
                        </Form.Item>
                    </Col>

                    <Col span={7}>
                        <Form.Item
                            label="验证方法"
                            name="verificationMethodId">
                            <Select
                                placeholder="验证方法"
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general(verificationMethodData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="级别"
                            name="membershipLevelId"
                            rules={[{ required: true, message: '请选择级别!' }]}>
                            <Select
                                placeholder="级别"
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general(membershipLevelData, { itemName: 'levelName' })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="余额"
                            name="balance">
                            <InputNumber style={{ width: 120 }} />
                        </Form.Item>
                    </Col>

                    <Col span={7}>
                        <Form.Item
                            label="会员到期"
                            name="expireDate"
                            tooltip='会员到期时间，默认：当前日期+3年'>
                            <DatePicker format="YYYY-MM-DD" style={{ width: 140 }} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="主卡id"
                            name="parentId"
                            tooltip='所要绑定的主卡id'>
                            <Select
                                placeholder="主卡id"
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general(membershipData, {
                                    includeNull: true,
                                    setItemNameFun: (item: any) => {
                                        const { id, membershipInfo } = item;
                                        return {
                                            id,
                                            name: `${id}【${membershipInfo?.membershipName}】`
                                        }
                                    }
                                })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={11}>
                        <Form.Item
                            label="商户"
                            name="merchantId"
                            rules={[{ required: true, message: '请选择商户!' }]}>
                            <Select
                                placeholder="商户"
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general(merchantData, { itemName: 'merchantName' })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="店铺"
                            name="shopId"
                            rules={[{ required: true, message: '请选择店铺!' }]}>
                            <Select
                                placeholder="店铺"
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general(shopData, { itemName: 'shopName' })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="附属上限"
                            name="maxChildren"
                            tooltip='绑定附属会员数量的上限'>
                            <InputNumber style={{ width: 70 }} />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="模式"
                            name="membershipModeId"
                            tooltip='附属卡是附属在某张主卡上，有些消费可以使用主卡'>
                            <Select
                                placeholder="会员模式"
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general(membershipMode)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="会员状态"
                            name="membershipStatusId">
                            <Select
                                placeholder="会员状态"
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general(membershipStatusData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="销售id"
                            name="salesId">
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="成长值"
                            name="growthPoints">
                            <InputNumber style={{ width: 105 }} />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            label="新客"
                            name="isNewCustomer"
                            tooltip='是否是新客状态'
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="是"
                                unCheckedChildren="否" />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            label="退款"
                            name="isAllowRefunds"
                            tooltip='是否充许退款'
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="充许"
                                unCheckedChildren="禁止" />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            label="默认"
                            name="isDefault"
                            tooltip='当前会员卡为默认卡'
                            valuePropName="checked"
                            initialValue={false}>
                            < Switch checked={false}
                                checkedChildren="是"
                                unCheckedChildren="否" />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="备注"
                            name="memo">
                            <Input.TextArea
                                rows={2}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item >
                            <WebUniversal {...subExtendProps} sendPageData={{ id: editingId }} />
                        </Form.Item>
                    </Col>

                </Row>
            )
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;